/* This is generated code, don't alter */
var IfcLogicalOperatorEnum;
(function (IfcLogicalOperatorEnum) {
    IfcLogicalOperatorEnum[IfcLogicalOperatorEnum["LOGICALAND"] = 0] = "LOGICALAND";
    IfcLogicalOperatorEnum[IfcLogicalOperatorEnum["LOGICALOR"] = 1] = "LOGICALOR";
    IfcLogicalOperatorEnum[IfcLogicalOperatorEnum["LOGICALXOR"] = 2] = "LOGICALXOR";
    IfcLogicalOperatorEnum[IfcLogicalOperatorEnum["LOGICALNOTAND"] = 3] = "LOGICALNOTAND";
    IfcLogicalOperatorEnum[IfcLogicalOperatorEnum["LOGICALNOTOR"] = 4] = "LOGICALNOTOR";
})(IfcLogicalOperatorEnum || (IfcLogicalOperatorEnum = {}));
const IfcLogicalOperatorEnumCount = 5;
export { IfcLogicalOperatorEnum, IfcLogicalOperatorEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcLogicalOperatorEnum = new Int32Array([3]);
let prefixSumAddressIfcLogicalOperatorEnum = new Uint32Array([0, 15, 27, 38, 50, 64]);
let slotMapIfcLogicalOperatorEnum = new Int32Array([3, 0, 1, 2, 4]);
let encodedDataIfcLogicalOperatorEnum = (new TextEncoder()).encode(".LOGICALNOTAND..LOGICALAND..LOGICALOR..LOGICALXOR..LOGICALNOTOR.");
let IfcLogicalOperatorEnumSearch = new MinimalPerfectHash(gMapIfcLogicalOperatorEnum, prefixSumAddressIfcLogicalOperatorEnum, slotMapIfcLogicalOperatorEnum, encodedDataIfcLogicalOperatorEnum);
export { IfcLogicalOperatorEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcLogicalOperatorEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcLogicalOperatorEnumSearch, input, cursor, endCursor);
}
